import { render, staticRenderFns } from "./MealIngredientPicker.vue?vue&type=template&id=088abb64&"
import script from "./MealIngredientPicker.vue?vue&type=script&lang=js&"
export * from "./MealIngredientPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports